/**
 * 联系客服下拉
 */
import React, { useState } from 'react'
import { Dropdown as AntDropdown } from 'antd'
import styles from './index.module.less'

const Dropdown = ({ placement = 'bottom', translateTxt, children }: any) => {
  const [open, setOpen] = useState(false)
  return (
    <AntDropdown
      placement={placement}
      overlayStyle={{
        minWidth: 176,
        height: 248,
        background: '#252627',
        borderRadius: 4,
        border: '1px solid #43444A',
      }}
      open={open}
      onOpenChange={(v: boolean) => setOpen(v)}
      overlay={() => {
        return (
          <div className={styles.application}>
            <div className="title">Creative Booster</div>
            <div className="title">{translateTxt?.('components:t21')}</div>
            <img
              style={{ marginTop: 12, marginBottom: 12 }}
              width={120}
              height={120}
              src="//static.creativebooster.com/ad-web/pay.png"
            />
            <div className="remark">{translateTxt?.('components:t22')}</div>
            <div className="remark">{translateTxt?.('components:t23')}</div>
          </div>
        )
      }}
    >
      {children}
    </AntDropdown>
  )
}

export default Dropdown
